<template>
  <div class="flex flex-col w-full">
    <input
      :id="id"
      v-model="phoneNumber"
      class="input text-sm border-2
          appearance-none flex-auto
          min-w-0 w-full h-12 px-3
          focus focus:outline-none
          active:outline-none
          disabled:text-gray-400"
      :class="{
        'border-gray-400' : !error,
        'border-red-600' : error,
        'focus:border-red-600' : error,
        'filled' : modelValue
      }"
      :style="{
        '--focus-border-color': !error ? global.primaryColor : '#dc2626'
      }"
      :type="type"
      :name="name"
      :autofocus="autofocus"
      :autocomplete="autocomplete"
      :disabled="$attrs.disabled"
      :maxlength="maxLength"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @input="sanitizePhoneNumber"
      @keyup="$emit('get-phone-number', getPhoneNumberAndCountryCode())"
    >
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
// eslint-disable-next-line
const intlTelInput = require('intl-tel-input');

declare global {
  interface Window {
    intlTelInputGlobals: any;
  }
}

export default defineComponent({
  name: 'Input',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: '',
      required: true
    },
    error: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 12
    }
  },
  emits: ['get-phone-number', 'focus', 'blur'],
  computed: {
    ...mapGetters([
      'global'
    ])
  },
  data() {
    return {
      phoneNumber: ''
    };
  },

  mounted () {
    const input = document.getElementById('tel');
    intlTelInput(input, {
      initialCountry: 'it',
      preferredCountries: ['it'],
      // onlyCountries: ['it', 'fr', 'de', 'gb']
    });
    if(input){
      input.addEventListener('countrychange', () => {
        this.$emit('get-phone-number', this.getPhoneNumberAndCountryCode());
      });
    }
  },
  methods: {
    onLabelClick (label: any) {
      label.srcElement.previousElementSibling.focus();
    },
    getPhoneNumberAndCountryCode() {
      let dialCode = '';
      const input = document.getElementById('tel');
      if (input != null) {
        const iti = window.intlTelInputGlobals.getInstance(input);
        dialCode = iti.getSelectedCountryData().dialCode.toString();    

        return {
          countryCode: `+${dialCode}`,
          number: this.phoneNumber
        };
      }
    },
    sanitizePhoneNumber(event: any) {
      this.phoneNumber = event.target.value.replace(/\D/g, '');
    }
  }
});
</script>
<style>
.input:focus + .label,
.input:active + .label,
.input.filled + .label {
  font-size: 0.65rem;
  transition: all 0.2s ease-out;
  top: -0.1rem;
  color: #7b808c;
}

.input {
  border-radius: 5px;
}

.input:focus {
  border-color: var(--focus-border-color) !important;
}

.label {
  transition: all 0.2s ease-out;
  top: 0.6rem;
  left: 0;
}

.label-disabled {
  font-size: 0.65rem;
  top: 0.1rem;
  left: 0;
}
</style>
